import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBadge from 'UIComponents/badge/UIBadge';
import styled from 'styled-components';
import { COMPARE_HEADER } from '../../../constants/pricing/PriceDisplayOverrides';
import { usePricingInfoFromProductConfigurations, useProductConfigurationsFromProductLineAndLevel } from '../../../hooks/upgradePageHooks';
import { useAppSelector } from '../../../reducers';
import { activeCurrencySelector } from '../../../selectors/CurrencySelectors';
import CurrentPlanButton from '../../../upgrade-page/CurrentPlanButton';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import { HighlightedPriceDisplay } from '../../common/pricing/HighlightedPriceDisplay';
import TrialPlanTableCTA from './TrialPlanTableCTA';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TableHeaderCell = styled.th.withConfig({
  displayName: "CompareTrialPlanTableHeaderCell__TableHeaderCell",
  componentId: "sc-19sg96y-0"
})(["text-align:center;font-weight:normal;position:relative;width:", ";padding:16px 0;"], ({
  columns
}) => columns < 3 ? `calc(50%/${columns})` : `calc(70%/${columns})`);
const ctaStyles = {
  width: '212px',
  padding: '11px'
};
const CompareTrialPlanTableHeaderCell = ({
  productLevel,
  columns,
  productLine,
  upgradePointProductLevel,
  currentTrialColumn,
  upgradePointApiName,
  purchaseMotions
}) => {
  const isHighlightedCell = upgradePointProductLevel === productLevel;
  // Seats scenarios have only one column because we don't have an additional column for a product to compare.
  const isSeatsScenario = columns <= 1;
  const productConfigurations = useProductConfigurationsFromProductLineAndLevel({
    productLine,
    productLevel
  });
  const pricingInfo = usePricingInfoFromProductConfigurations(productConfigurations);
  const currencyCode = useAppSelector(activeCurrencySelector);
  const purchaseMotionLoaded = Boolean(productConfigurations && productConfigurations.length);
  return /*#__PURE__*/_jsxs(TableHeaderCell, {
    columns: columns,
    scope: "col",
    children: [isHighlightedCell && /*#__PURE__*/_jsx(UIBadge, {
      use: "new",
      style: {
        position: 'static',
        top: '0'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.highlightedMerchCards.currentTrial"
      })
    }), /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        className: "flex-column m-top-1",
        message: `merchCards.businessObjectives.suite.${productLevel}.${productLine}.title`
      })
    }), currentTrialColumn && !isSeatsScenario ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(HighlightedPriceDisplay, {
        pricingInfo: pricingInfo,
        skuId: pricingInfo.skuId,
        useLargePrice: false,
        priceDisplayOverride: COMPARE_HEADER,
        showDiscount: true,
        wrapperStyle: {
          textAlign: 'center'
        },
        concise: true
      }), /*#__PURE__*/_jsx("div", {
        className: "m-top-4",
        children: /*#__PURE__*/_jsx(CurrentPlanButton, {
          ctaStyles: Object.assign({}, ctaStyles, {
            visibility: 'visible'
          }),
          productLine: productLine
        })
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(HighlightedPriceDisplay, {
        pricingInfo: pricingInfo,
        skuId: pricingInfo.skuId,
        useLargePrice: false,
        priceDisplayOverride: COMPARE_HEADER,
        showDiscount: true,
        wrapperStyle: {
          textAlign: 'center'
        },
        concise: true
      }), /*#__PURE__*/_jsx("div", {
        className: "m-top-4",
        children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
          isLoading: !purchaseMotionLoaded,
          heights: [38],
          widths: [210],
          className: "flex-column align-center",
          Content: TrialPlanTableCTA,
          contentProps: {
            currencyCode,
            productConfigurations,
            upgradePointApiName,
            purchaseMotions,
            ctaStyles,
            trackingSource: 'HC0119-Table-Header'
          }
        })
      })]
    })]
  }, productLevel);
};
export default CompareTrialPlanTableHeaderCell;